import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const quotes = [
  {
    q: "Credit Stone Digital is the first platform that lets me see my hedge fund exposures and banking activity calmly, in one place.",
    name: "Kathie Corl",
    role: "Principal · Single-Family Office",
    avatar:
      "https://cdn.prod.website-files.com/6554f9899be30f30974e7985/655690bac0662821abd804e2_kathie-corl-avatar-image-bnkify-x-webflow-template.jpg",
  },
  {
    q: "Discreet, institutional, and beautifully built. Exactly what private clients have been waiting for from a digital platform.",
    name: "Sophie Moore",
    role: "Private Investor",
    avatar:
      "https://cdn.prod.website-files.com/6554f9899be30f30974e7985/655690baca9a07e2a4778e37_sophie-moore-avatar-image-bnkify-x-webflow-template.jpg",
  },
  {
    q: "I now have visibility on investment mandates I would not otherwise have seen — and the reporting is genuinely gorgeous.",
    name: "Matt Cannon",
    role: "Private Investor",
    avatar:
      "https://cdn.prod.website-files.com/6554f9899be30f30974e7985/655690ba62912e4b88da3731_matt-cannon-avatar-image-bnkify-x-webflow-template.jpg",
  },
];

export default function Testimonials() {
  return (
    <section
      id="trust"
      className="relative bg-[#0A0B0D] py-32 sm:py-40 lg:py-48 border-t border-[#1F2126]"
      data-testid="testimonials-section"
    >
      <div className="max-w-[1700px] mx-auto px-6 sm:px-10 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-20">
          <div className="col-span-12 md:col-span-3 t-mono text-[#7A7A78]">
            — § 07 / Customers
          </div>
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 1.2, ease }}
            className="col-span-12 md:col-span-9 t-display text-[#F4F2EC] text-3xl sm:text-4xl lg:text-5xl leading-[1] tracking-[-0.035em]"
          >
            What private <span className="text-[#BFBDB6]">clients say.</span>
          </motion.h3>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {quotes.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 1, ease, delay: i * 0.1 }}
              className="col-span-12 md:col-span-4 border-t border-[#1F2126] pt-10 flex flex-col gap-10 min-h-[300px]"
              data-testid={`testimonial-${i}`}
            >
              <div className="t-mono text-[#7A7A78]">N°0{i + 1}</div>
              <blockquote className="t-body text-[#F4F2EC] text-lg sm:text-xl leading-[1.4] tracking-[-0.015em] font-light flex-1">
                "{t.q}"
              </blockquote>
              <figcaption className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt=""
                  aria-hidden="true"
                  className="w-9 h-9 rounded-full object-cover grayscale border border-[#2A2C30]"
                  draggable="false"
                  style={{ filter: "blur(6px) grayscale(1)" }}
                />
                <div>
                  <div
                    className="t-body text-sm text-[#F4F2EC]"
                    style={{ filter: "blur(5px)", userSelect: "none" }}
                    aria-label="Name redacted for privacy"
                  >
                    {t.name}
                  </div>
                  <div className="t-mono text-[#7A7A78] mt-0.5">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
